<div class="modal-body position-relative" [formGroup]="uploadLayer">
  <ul ngbNav #layerTabs="ngbNav" class="nav-tabs nav-tabs-sm">
    <li ngbNavItem="source">
      <a ngbNavLink>Source</a>
      <ng-template ngbNavContent>
        <div class="px-2 pb-3 perfect-scroll">
          <div class="form-group">
            <label class="form-label">Dataset</label>
            <div class="card border-0 bg-light py-2 px-3">
              <div class="d-flex align-items-center">
                <i [class]="icon"></i>
                <p class="mb-0">{{ uploadLayer?.value?.name }}</p>
              </div>
            </div>

            <maplix-icon-text-button
              [fullWidth]="true"
              [icon]="'remixicon-repeat-2-fill'"
              [buttonType]="'light'"
              [buttonText]="'Change datasource'"
              (action)="onOpenDatasetModal()"
            ></maplix-icon-text-button>
          </div>
        </div>
      </ng-template>
    </li>
    <li ngbNavItem="style" [disabled]="!uploadLayer.get('typeName')?.value">
      <a ngbNavLink>Style</a>
      <ng-template ngbNavContent>
        <div class="px-2 pb-3 perfect-scroll">
          <ng-container [formGroup]="uploadLayer">
            <!-- Ask style source -->
            <div class="form-group" *ngIf="styleSources?.length > 1">
              <div class="caption mb-3">Layer style</div>
              <label class="form-label">Style type</label>
              <ng-select
                [items]="styleSources"
                formControlName="styleSource"
                bindValue="value"
                [clearable]="false"
                [searchable]="false"
              >
                <ng-template ng-label-tmp let-item="item">
                  <i [class]="item.icon"></i>
                  <span class="ml-2">{{ item.label }}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <i [class]="item.icon"></i>
                  <span class="ml-2">{{ item.label }}</span>
                </ng-template>
              </ng-select>
            </div>

            <!-- If rule based style source is selected -->
            <ng-container *ngIf="uploadLayer?.get('styleSource')?.value === 'rule-based' && !selectedRule">
              <!-- Show a table of all rules with an add and edit button -->
              <label class="form-label">Rules</label>
              <div class="table-responsive">
                <table class="table table-sm border-bottom">
                  <tbody>
                    <tr *ngFor="let styleCondition of uploadLayer.get('styleConditions')['controls']">
                      <td>
                        <ng-container
                          *ngFor="
                            let title of styleCondition.get('title')['controls']
                              | formGroupFilter
                                : {
                                    field: 'i18n',
                                    filter: mapService.language
                                  }
                          "
                        >
                          {{ title.get('value').value }}
                        </ng-container>
                      </td>
                      <td>
                        <div class="d-flex justify-content-end">
                          <button
                            class="btn btn-xs mr-1 btn-light"
                            (click)="onEditConditions(styleCondition)"
                            ngbTooltip="Edit conditions"
                          >
                            <i class="remixicon-list-settings-line"></i>
                          </button>
                          <button
                            class="btn btn-xs mr-1 btn-light"
                            (click)="onEditRule(styleCondition)"
                            ngbTooltip="Edit style"
                          >
                            <i class="remixicon-pencil-line"></i>
                          </button>
                          <button
                            class="btn btn-xs btn-danger"
                            *ngIf="uploadLayer.get('styleConditions')['controls'].length > 1"
                            (click)="onRemoveRule(uploadLayer.get('styleConditions'), styleCondition)"
                            ngbTooltip="Remove"
                          >
                            <i class="remixicon-indeterminate-circle-fill"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-center">
                <maplix-icon-text-button
                  [buttonType]="'primary'"
                  [wide]="true"
                  [icon]="'remixicon-add-circle-fill'"
                  [buttonText]="'Add rule'"
                  (click)="onAddRule(uploadLayer.get('styleConditions'))"
                >
                </maplix-icon-text-button>
              </div>
            </ng-container>

            <ng-container *ngIf="selectedRule">
              <label
                class="form-label mt-0 mb-3 d-flex align-items-center clickable"
                (click)="selectedRule = undefined"
              >
                <i class="fe-arrow-left mr-2"></i> Back
              </label>
              <ng-container *ngIf="selectedRuleView === 'style'">
                <maplix-vector-layer-style
                  [dataLayer]="uploadLayer"
                  [styleCondition]="selectedRule"
                  [mapType]="mapType"
                  [apiUrl]="apiUrl"
                  [language]="mapService.language"
                  [isUpload]="true"
                >
                </maplix-vector-layer-style>
              </ng-container>
              <ng-container *ngIf="selectedRuleView === 'conditions'">
                <maplix-rule-editor
                  [dataLayer]="uploadLayer"
                  [rules]="selectedRule.get('rules')"
                  [uploadId]="uploadLayer.get('_id')?.value"
                  [mapType]="mapType"
                  [language]="mapService.language"
                  [geometryType]="uploadLayer.get('geomType').value"
                >
                </maplix-rule-editor>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="uploadLayer?.get('styleSource').value !== 'rule-based'">
              <ng-container *ngFor="let styleCondition of uploadLayer?.get('styleConditions')['controls']">
                <maplix-vector-layer-style
                  [dataLayer]="uploadLayer"
                  [styleCondition]="styleCondition"
                  [mapType]="mapType"
                  [apiUrl]="apiUrl"
                  [language]="mapService.language"
                  [isUpload]="true"
                >
                </maplix-vector-layer-style>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
    </li>
    <li ngbNavItem="labels" [disabled]="!uploadLayer.get('typeName')?.value">
      <a ngbNavLink>Labels</a>
      <ng-template ngbNavContent>
        <div class="px-2 pb-3 perfect-scroll">
          <maplix-vector-layer-labels
            [geometryType]="uploadLayer.get('geomType')?.value"
            [labelControl]="labelForm"
            [uploadId]="uploadLayer.get('_id')?.value"
            [styleSource]="uploadLayer.get('styleSource')?.value"
          ></maplix-vector-layer-labels>
        </div>
      </ng-template>
    </li>
    <li ngbNavItem="legend" [disabled]="!uploadLayer.get('typeName')?.value">
      <a ngbNavLink>Legend</a>
      <ng-template ngbNavContent>
        <div class="px-2 pb-3 perfect-scroll">
          <div class="form-group">
            <label class="form-label">Title</label>
            <ng-container
              *ngFor="
                let title of uploadLayer?.get('title')['controls']
                  | formGroupFilter: { field: 'i18n', filter: mapService.language }
              "
              [formGroup]="title"
            >
              <input type="text" class="form-control" formControlName="value" />
            </ng-container>
          </div>
          <div class="form-group">
            <label class="form-label">Help text</label>
            <ng-container
              *ngFor="
                let helptext of uploadLayer.get('helptext')['controls']
                  | formGroupFilter: { field: 'i18n', filter: mapService.language }
              "
              [formGroup]="helptext"
            >
              <maplix-quill-editor [control]="helptext.get('value')" [apiUrl]="apiUrl" [placeholder]="'Help text'">
              </maplix-quill-editor>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </li>
    <li ngbNavItem="options" [disabled]="!uploadLayer.get('typeName')?.value">
      <a ngbNavLink>Options</a>
      <ng-template ngbNavContent>
        <div class="px-2 pb-3 perfect-scroll">
          <div class="form-group mb-4">
            <label class="form-label">
              Zoom extent
              <i
                class="remixicon-question-line text-muted ml-2 clickable"
                [ngbPopover]="'The layer will not be visible beyond these zoom levels.'"
                placement="bottom"
                container="body"
              ></i>
            </label>
            <div class="position-relative">
              <maplix-double-slider
                [min]="2"
                [max]="22"
                [minControl]="uploadLayer?.get('minZoom')"
                [maxControl]="uploadLayer?.get('maxZoom')"
                [themeColors]="themeColors"
              ></maplix-double-slider>
              <maplix-map-zoom-indicator [map]="mapService.map"></maplix-map-zoom-indicator>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Visibility in legend</label>
            <ng-select
              [items]="visibilityItems"
              bindLabel="label"
              bindValue="value"
              formControlName="showOnLegend"
              [clearable]="false"
              [searchable]="false"
              appendTo=".layer-editor"
            >
              <ng-template ng-option-tmp let-item="item">
                <div class="d-flex align-items-center">
                  <i [class]="item.icon + ' mr-2'"></i>
                  {{ item.label }}
                </div>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <div class="d-flex align-items-center">
                  <i [class]="item.icon + ' mr-2'"></i>
                  {{ item.label }}
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div class="form-group">
            <label class="form-label">
              Element detail popup
              <i
                class="remixicon-question-line text-muted ml-2 clickable"
                [ngbPopover]="'Not applicable for layers with the \'Clustered\' style type.'"
                placement="bottom"
                container="body"
              ></i>
            </label>
            <ng-select
              [items]="popupItems"
              bindLabel="label"
              bindValue="value"
              formControlName="isSelectable"
              [clearable]="false"
              [searchable]="false"
              appendTo=".layer-editor"
            >
              <ng-template ng-option-tmp let-item="item">
                <div class="d-flex align-items-center">
                  <i [class]="item.icon + ' mr-2'"></i>
                  {{ item.label }}
                </div>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <div class="d-flex align-items-center">
                  <i [class]="item.icon + ' mr-2'"></i>
                  {{ item.label }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="layerTabs"></div>
</div>
